<script setup>
import ApplicationLogo from '@/components/ApplicationLogo.vue';
import LanguageSelector from '@/components/LanguageSelector.vue';
</script>

<template>
    <div class="py-3 bg-info">
        <div class="container d-flex justify-content-between align-items-center">
            <div>
                {{ $t('contact_support') }}: <a href="mailto:support@greentechmining.de">support@greentechmining.de</a>
                <!-- NOTE: Contact form not implemented in API yet {{ $t('contact_support') }}: <a href="#" data-bs-toggle="modal" data-bs-target="#supportModal">support@greentechmining.de</a> -->
            </div>
            <LanguageSelector></LanguageSelector>
        </div>
    </div>
    <div class="container"> 
        <div class="row align-items-center gy-5">
            <div class="col-4 col-sm-5 col-lg-auto order-0">
                <ApplicationLogo fillColor="#fff"/>
            </div>
            <div class="col-12 col-lg-6 ps-lg-5 order-3 order-lg-1">
                <slot name="title"></slot>
            </div>
            <div class="col-auto ms-auto order-2">
                <router-link to="/profile" class="text-body me-4 me-sm-5">{{ $t('navigation.profile') }} <font-awesome-icon class="ms-2" :icon="['fas', 'user']" /></router-link>
                <a class="text-body " href="#" @click="logout">{{ $t('navigation.logout') }} <font-awesome-icon class="ms-2" :icon="['fas', 'right-from-bracket']" /></a>
            </div>
        </div>
    </div>

    <slot />

    <!-- Modal -->
    <div class="modal fade" id="supportModal" tabindex="-1" data-bs-backdrop="true" aria-labelledby="supportModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                <div class="modal-body">
                    <div class="display-5">Support Request</div>
                    <h1>We are here to help you</h1>
                    <p>What is your request about? Please give us as much information as possible. A team member will get in touch with you within the next 24 hours to help you with your request (usually even faster). Further communication will take place by e-mail.</p>
                    <Form @submit="supportMessage">
                        <fieldset>
                            <label for="supportSubject" class="form-label"><small>Select category</small></label>
                            <div class="mb-3">
                                <Field as="select" id="supportSubject" name="supportSubject" class="form-select form-select-lg text-dark" >
                                    <option value="Payment">Payment</option>
                                    <option value="Technical">Technical</option>
                                    <option value="General">General</option>
                                </Field>
                            </div>
                            <div class="mb-3">
                                <label for="supportComment" class="form-label"><small>Please describe your request</small></label>
                                <Field as="textarea" type="text" id="supportComment" name="supportComment" rows="5" class="form-control text-dark" />
                            </div>
                            <button class="btn btn-primary mt-4" type="submit">Send</button>
                        </fieldset>
                        <div class="state position-absolute start-0 top-0 end-0 bottom-0 d-flex justify-content-center align-items-center">
                            <div class="loading text-center position-absolute">
                                <div class="icon display-1 mb-3">
                                    <font-awesome-icon class="bg-white" :icon="['fas', 'circle-notch']" size="2xl" spin spin-reverse/>
                                </div>
                            </div>
                            <div class="success-message text-center position-absolute">
                                <div class="icon display-1 mb-3">
                                    <font-awesome-icon class="text-success bg-white" :icon="['fas', 'circle-check']" size="2xl"/>
                                </div>
                                <div class="message">
                                    Your request has been successfully sent.
                                </div>
                            </div>
                            <div class="failure-message text-center position-absolute">
                                <div class="icon display-1 mb-3">
                                    <font-awesome-icon class="text-danger bg-white" :icon="['fas', 'circle-xmark']" size="2xl"/>
                                </div>
                                <div class="message">
                                    There was an error. Please try again later or contact us per mail.
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import bootstrap from 'bootstrap/dist/js/bootstrap'
    import { useUserStore } from '@/js/user';
    import { Form, Field, ErrorMessage, configure } from 'vee-validate';
    import * as yup from 'yup';

    configure({
        validateOnBlur: false, // controls if `blur` events should trigger validation with `handleChange` handler
        validateOnChange: false, // controls if `change` events should trigger validation with `handleChange` handler
        validateOnInput: false, // controls if `input` events should trigger validation with `handleChange` handler
        validateOnModelUpdate: false, // controls if `update:modelValue` events should trigger validation with `handleChange` handler
    });

    export default {
        methods: {
            logout(event) {
                const userStore = useUserStore()
                userStore.logout()
                event.preventDefault();
            },
            async supportMessage(values, eventHandler) {
                let userStore = useUserStore()
                eventHandler.evt.target.classList.add('submitted')

                let supportData = {
                    body: values['supportComment'],
                    subject: 'Request regarding ' + values['supportSubject']
                }

                userStore.sendFormSupport(supportData).then((response) => {  
                    if(response == 200) {
                        eventHandler.evt.target.classList.add('success')
                    } else
                        eventHandler.evt.target.classList.add('failure')

                    setTimeout(() => {
                        eventHandler.evt.target.classList.remove('submitted')
                        eventHandler.evt.target.classList.remove('success')
                        eventHandler.evt.target.classList.remove('failure')
                    }, 4000);
                }).catch(error => {
                    
                });
            }
        }
    }
</script>